import { PostMessageModel } from "../models/common/post-message.model";

export const postMessageForWebview = (method: string, param?: any) => {
    try {
        let message = new PostMessageModel(method, param);
        let vm = window as any;
        console.log("win", vm.chrome);
        console.log("mobile-ios", vm.webkit);
        console.log("mobile-android", vm.jsHandler);
        console.log("message", message);
        if (vm.chrome && vm.chrome.webview) {
            // win app
            console.log("win-webview", vm.chrome.webview);
            vm.chrome.webview.postMessage(message);
        } else if (vm.webkit && vm.webkit.messageHandlers) {
            // ios
            console.log(
                "mobile-ios-messageHandlers",
                vm.webkit.messageHandlers
            );
            vm.webkit.messageHandlers.jsHandler.postMessage(message);
        } else if (vm.jsHandler) {
            // android
            console.log("mobile-android-message", message.method);
            vm.jsHandler.postMessage(message.method.toString());
        }
    } catch (error) {
        console.log("postMessageForWebview", error);
    }
};
